import React from 'react'
import escape from 'escape-html'

function replaceAll(string, toReplace, replaceAs) {
  function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
  }

  return string.replace(new RegExp(escapeRegExp(toReplace), 'g'), replaceAs)
}

function parse(response) {
  let toReplace = {
    '&lt;bold&gt;': '<b>',
    '&lt;/bold&gt;': '</b>',
    '&lt;italic&gt;': '<i>',
    '&lt;/italic&gt;': '</i>',
    '&lt;superscript&gt;': '<sup>',
    '&lt;/superscript&gt;': '</sup>',
    '&lt;subscript&gt;': '<sub>',
    '&lt;/subscript&gt;': '</sub>',
    '\n': '<br />',
    ' -': '&nbsp;-',
  }

  let body = escape(response)

  for (let replace in toReplace)
    body = replaceAll(body, replace, toReplace[replace])

  return body
}

// hadPreviousError={ !hideGhosting && response.previousError}
// response={response.response}
// responseNumber={response.number}

function Response({
  response,
  onClick = () => {},
  hadPreviousError,
  responseNumber,
  onDoubleClick = () => {},
  spacing = false,
  zeroWidthSpace = false,
  nextResponse = null,
}) {
  return (
    <span className={`response ${hadPreviousError ? 'previous-error' : ''}`}>
      {response[0] !== '-' && spacing ? (
        <React.Fragment>&#x2009;</React.Fragment>
      ) : (
        ''
      )}
      <span
        id={`response-${responseNumber}`}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        className="response-text"
        dangerouslySetInnerHTML={{ __html: parse(response) }}
      ></span>
      {nextResponse?.[0] !== '-' && spacing ? (
        <React.Fragment>&#x2009;</React.Fragment>
      ) : (
        ''
      )}

      {zeroWidthSpace ? <React.Fragment>&#x200B;</React.Fragment> : ''}
    </span>
  )
}

export default Response
